export default function patrimonygroups(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                patrimonygroup: action.patrimonygroup,
            }
        default:
            return state;
    }
}
